import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './admin-currencies.hbs'
import currencyItem from './admin-currencies-item.hbs'
import FormView from 'scoreboard/components/form-view'
import currency from 'scoreboard/components/currency'
import arrayToHash from 'scoreboard/components/array-to-hash'

var AdminCurrencies = Backbone.View.extend({

	// this.options.data is data about the currencies (see CurrenciesResponse.java)

	tagName: 'form',

	className: 'admin-currencies',

	initialize: function(options) {
		this.options = options || {}

		var data = this.options.data
		this.supportedCurrencies = _.sortBy(data.supportedCurrencies, 'description')
		this.availableCurrencyCodes = arrayToHash(data.availableCurrencyCodes)
		this.usedCurrencyCodes = arrayToHash(data.usedCurrencyCodes)

		this.formView = new FormView({ el: this.el, submit: this.submit.bind(this) })
	},

	render: function() {
		this.$el.empty().append(template())
		var html = ''
		_.forEach(this.supportedCurrencies, function(c) {
			var used = this.usedCurrencyCodes[c.code]
			var available = this.availableCurrencyCodes[c.code]
			var context = _.extend({
				disabled: used,
				checked: used || available,
				label: currency.label(c)
			}, c)
			html += currencyItem(context)
		}.bind(this))
		this.$('.currency-options').html(html)

		this.formView.start()

		return this
	},

	submit: function() {
		// an array of the available currency codes
		var codes = _.map(this.$('[type=checkbox]:checked'), function(input) {
			return input.name
		})
		return $.ajax({
			method: 'post',
			url: 'api/admin/app/currencies',
			data: JSON.stringify(codes),
			success: function() {
				// do this before triggering done
				this.updateCurrencies(codes)
				this.trigger('done')
			}.bind(this),
			error: function(xhr) {
				this.formView.error(xhr)
			}.bind(this)
		})
	},

	updateCurrencies: function(codes) {
		var supportedByCode = _.keyBy(this.supportedCurrencies, function(currency) {
			return currency.code
		})
		var currencies = _.map(codes, function(code) {
			return supportedByCode[code]
		})
		currency.update(currencies)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView], 'remove')
	}

})

export default AdminCurrencies

AdminCurrencies.__filename__ = 'admin/configuration/admin-currencies.js'
